export const getInventoryData = (payload) => {
    return{
        type:"GET_INVENTORY_DATA",
        data:payload
    }
}

export const addDishToReplenish = (payload) => {
    return {
        type:"ADD_DISH_TO_REPLENISH",
        data:payload
    }
}

export const removeDishToReplenish = (payload) => {
    return {
        type:"REMOVE_DISH_TO_REPLENISH",
        data:payload
    }
}

export const updateDishToReplenish = (payload) => {
    return {
        type:"UPDATE_DISH_TO_REPLENISH",
        data:payload
    }
}

export const setReplenishPlan = (payload) => {
    return {
        type:"SET_REPLENISH_PLAN",
        data:payload
    }
}

export const clearData = (payload) => {
    return {
        type:"CLEAR_DATA",
        data:payload
    }
}

export const removeFromReplenishmentData = (payload) => {
    return {
        type:"REMOVE_FROM_REPLENISH_DATA",
        data:payload
    }
}

export const addToReplenishmentData = (payload) => {
    return {
        type:"ADD_TO_REPLENISH_DATA",
        data:payload
    }
}

export const updateReplenishmentData = (payload) => {;
    return {
        type:"UPDATE_REPLENISH_DATA",
        data:payload
    }
}

export const clearReplenishmentData = (payload) => {
    return {
        type:"CLEAR_REPLENISHMENT_DATA",
        data:payload
    }
}
